"use client";

import { createContext, useCallback, useContext, type ReactNode } from "react";
import { toast } from "sonner";

const stepErrorToastClassNames = {
  toast:
    "!border-destructive !border-2 !bg-red-100 !text-red-950 dark:!bg-red-950 dark:!text-red-50 dark:!border-destructive [&_[data-icon]]:!text-destructive",
} as const;

const STEP_ERROR_TOAST_ID = "vehicle-assignment-step-error";

type VehicleAssignmentStepErrorContextValue = {
  showStepError: (message: string) => void;
};

const VehicleAssignmentStepErrorContext =
  createContext<VehicleAssignmentStepErrorContextValue | null>(null);

function VehicleAssignmentStepErrorProvider({
  children,
}: {
  children: ReactNode;
}) {
  const showStepError = useCallback((message: string) => {
    toast.error(message, {
      id: STEP_ERROR_TOAST_ID,
      classNames: stepErrorToastClassNames,
    });
  }, []);

  return (
    <VehicleAssignmentStepErrorContext.Provider value={{ showStepError }}>
      {children}
    </VehicleAssignmentStepErrorContext.Provider>
  );
}

function useVehicleAssignmentStepError() {
  const context = useContext(VehicleAssignmentStepErrorContext);
  if (context === null) {
    throw new Error(
      "useVehicleAssignmentStepError must be used within VehicleAssignmentStepErrorProvider",
    );
  }
  return context;
}

export { VehicleAssignmentStepErrorProvider, useVehicleAssignmentStepError };
